module.exports = __webpack_public_path__ + "3c2e1b87f988598fd59d376c40e3256d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.html
// module id = 2394
// module chunks = 0